import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LuPresentation, LuPlayCircle, LuArrowRight, LuX } from "react-icons/lu";
import * as styled from "./PlatformNews.styled";
import { fetchAllPlatformLessons } from "../../../helpers/materials/platformLessons";
import { OPEN_EVENT } from "../../PlatformLessonsTour/PlatformLessonsTour";

// Банер «Нові уроки на платформі» вгорі головної вчителя (англійська). Можна сховати — запамʼятовуємо на пристрої
const hiddenKey = (teacherId) => `platformNewsHidden:${teacherId}`;

function PlatformNews({ teacher }) {
  const navigate = useNavigate();
  const [lessonsCount, setLessonsCount] = useState(0);
  const [hidden, setHidden] = useState(() => {
    try {
      return window.localStorage.getItem(hiddenKey(teacher?._id)) === "1";
    } catch (error) {
      return false;
    }
  });

  useEffect(() => {
    if (teacher?.accessType !== "en" || hidden) return;
    fetchAllPlatformLessons()
      .then((lessons) => setLessonsCount(lessons.length))
      .catch(() => {});
  }, [teacher?.accessType, hidden]);

  if (hidden || !lessonsCount) return null;

  const hide = () => {
    try {
      window.localStorage.setItem(hiddenKey(teacher._id), "1");
    } catch (error) {}
    setHidden(true);
  };

  return (
    <styled.Banner>
      <styled.Close type="button" aria-label="Сховати" onClick={hide}>
        <LuX size={18} />
      </styled.Close>
      <styled.Icon>
        <LuPresentation size={30} />
      </styled.Icon>
      <styled.Text>
        <styled.Badge>Новинка</styled.Badge>
        <h3>Нові уроки прямо на платформі</h3>
        <p>
          Інтерактивні презентації замість Canva, ДЗ учня — в кабінеті. Вже {lessonsCount} уроків для дорослих Beginner.
        </p>
      </styled.Text>
      <styled.Actions>
        <styled.Light type="button" onClick={() => window.dispatchEvent(new Event(OPEN_EVENT))}>
          <LuPlayCircle size={18} /> Як це працює
        </styled.Light>
        <styled.Accent
          type="button"
          onClick={() => {
            try {
              window.localStorage.setItem("materialsMode", "platform");
            } catch (error) {}
            navigate("/teacher/materials");
          }}
        >
          Відкрити уроки <LuArrowRight size={18} />
        </styled.Accent>
      </styled.Actions>
    </styled.Banner>
  );
}

export default PlatformNews;
